import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router";

const LoginButton = ({
  returnTo,
  signup = false,
  buttonLabel,
  className = "",
}: {
  returnTo?: string;
  signup?: boolean;
  buttonLabel?: string;
  className?: string;
}) => {
  const { loginWithRedirect } = useAuth0();
  const { pathname } = useLocation();
  const loginParams: {
    appState: { returnTo: string };
    authorizationParams?: { screen_hint: string };
  } = {
    appState: { returnTo: returnTo ? returnTo : pathname },
  };
  if (signup) {
    loginParams.authorizationParams = { screen_hint: "signup" };
  }
  return (
    <button
      className={`login-button ${className}`}
      onClick={() => loginWithRedirect(loginParams)}
    >
      {buttonLabel ? buttonLabel : signup ? "Sign Up" : "Log In"}
    </button>
  );
};

export default LoginButton;
